import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { ExternalURL } from '../../../../../../../../common/components/Toolbar/ToolbarItems/externalURL';
import {
  smokeGray,
  translucentGray,
  white,
} from '../../../../../../styling/theme';

interface DropdownItemProps {
  first: boolean;
  last: boolean;
}

export const DropdownItem = styled.div<DropdownItemProps>`
  border-radius: 4px;
  background: ${white};
  color: ${smokeGray};
  width: 100%;
  height: 40px;
  margin: 2px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in;
  padding: 0 20px;
  gap: 16px;
  justify-content: flex-start;
  ${({ first, last }) => {
    if (first)
      return css`
        border-radius: 24px 24px 4px 4px;
      `;
    if (last)
      return css`
        border-radius: 4px 4px 24px 24px;
      `;
    return css`
      border-radius: 4px;
    `;
  }}
  &:hover {
    background: ${translucentGray};
    color: ${smokeGray};
  }
`;

export const DropdownText = styled.span`
  color: ${smokeGray};
  font-size: 14px;
`;

const ProfileItemsList = ({ childrenList, inviteId }) => {
  const handleClickExternalURL = (option) => {
    return option.onClick && option.inviteBtn
      ? () =>
          option.onClick(
            `${window.location.origin}/invite?referrerId=${inviteId}`,
          )
      : option.onClick;
  };
  return (
    <div className="p-0 mt-[12px]">
      <div className="flex flex-col w-full">
        {childrenList.map((option, i: number) => (
          <>
            {
              {
                intURL: (
                  <Link
                    to={option.url}
                    className="no-underline"
                    onClick={option.onClick}
                  >
                    <DropdownItem
                      first={i === 0}
                      last={i === childrenList.length - 1}
                      aria-label={`${option.text
                        .split(' ')
                        .join('-')
                        .toLowerCase()}-profile-list-item`}
                    >
                      {option.icon}
                      <DropdownText>{option.text}</DropdownText>
                    </DropdownItem>
                  </Link>
                ),
                extURL: (
                  <ExternalURL
                    className="p-0"
                    href={option.url}
                    target={option.newTab ? '_blank' : ''}
                  >
                    <DropdownItem
                      onClick={handleClickExternalURL(option)}
                      first={i === 0}
                      last={i === childrenList.length - 1}
                    >
                      {option.icon}
                      <DropdownText>{option.text}</DropdownText>
                    </DropdownItem>
                  </ExternalURL>
                ),
                children: <>{option.children}</>,
              }[option.type]
            }
          </>
        ))}
      </div>
    </div>
  );
};

export default ProfileItemsList;
